module.exports = __webpack_public_path__ + "static/media/bg_on_boarding1.8c72ce10.png";